export const sendRequest = async (url, method, body, options = {}, headers = {}, contentType = 'application/json') => {
 
  try {
    const requestParams = {
      method,
      credentials: 'include',
      headers: {
        'Content-Type': contentType,
        ...headers
      },
      ...options,
      body
    };

    return await fetch(url, requestParams);

  } catch (error) {
      console.error(error);
      return null;
  }

};